import { useMemo } from 'react';
import { compact } from 'lodash';

import { createStateSelectorHook } from 'src/lib/sweetState';

import { BrandVoicesStore } from './BrandVoicesStore';

const useBrandVoicesState = createStateSelectorHook(BrandVoicesStore, ['brandVoicesAssets']);

export const useBrandVoiceAssets = ({ brandVoiceId }) => {
  const { brandVoicesAssets } = useBrandVoicesState();

  return useMemo(() => {
    const brandVoice = brandVoicesAssets.find((brandVoice) => brandVoice.id === brandVoiceId);

    return {
      customModels: brandVoice ? compact(brandVoice?.customModels) : [],
      toneOfVoices: brandVoice ? compact(brandVoice?.toneOfVoices) : [],
      targetAudiences: brandVoice ? compact(brandVoice?.targetAudiences) : [],
      brandBriefs: brandVoice ? compact(brandVoice?.brandBriefs) : [],
      brandTerms: brandVoice ? compact(brandVoice?.brandTerms) : [],
      customFormats: brandVoice ? compact(brandVoice?.customFormats) : [],
      customFormatGroups: brandVoice ? compact(brandVoice?.customFormatGroups) : [],
    };
  }, [brandVoicesAssets, brandVoiceId]);
};
